module.exports = __webpack_public_path__ + "static/img/221.7c8cce2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/221.jpg
// module id = VnXR
// module chunks = 0